document.addEventListener("DOMContentLoaded", function () {
  const boutiqueLink = Array.from(document.querySelectorAll('.header--primary-nav a'))
    .find(link => link.textContent.trim().toLowerCase().includes("boutique"));

  const submenu = document.querySelector('#boutique-submenu');

  if (boutiqueLink && submenu) {
    let closeTimeout;

    const openSubmenu = () => {
      clearTimeout(closeTimeout);
      submenu.classList.add("open");
      submenu.style.height = submenu.scrollHeight + "px";
    };

    const closeSubmenu = () => {
      submenu.style.height = submenu.scrollHeight + "px";
      requestAnimationFrame(() => {
        submenu.style.height = "0";
        submenu.classList.remove("open");
      });
    };

    const maybeCloseSubmenu = () => {
      closeTimeout = setTimeout(() => {
        if (!boutiqueLink.matches(':hover') && !submenu.matches(':hover')) {
          closeSubmenu();
        }
      }, 150);
    };

    // ⚡ Seulement sur desktop → hover
    if (window.matchMedia("(min-width: 1025px)").matches) {
      boutiqueLink.addEventListener("mouseenter", openSubmenu);
      boutiqueLink.addEventListener("mouseleave", maybeCloseSubmenu);
      submenu.addEventListener("mouseenter", () => clearTimeout(closeTimeout));
      submenu.addEventListener("mouseleave", maybeCloseSubmenu);
    }

    // ⚡ Mobile → on laisse Shopify gérer le clic normalement (pas d'event.preventDefault)
    // Donc rien à faire ici, ton drawer s’ouvrira normalement

    // Gestion des onglets
    const tabs = submenu.querySelectorAll('.submenu-tab');
    const previews = submenu.querySelectorAll('.submenu-products');

    tabs.forEach(tab => {
      tab.addEventListener('mouseenter', () => {
        const target = tab.dataset.collection;

        tabs.forEach(t => t.classList.remove('active'));
        previews.forEach(p => p.classList.remove('active'));

        tab.classList.add('active');
        const preview = submenu.querySelector(`.submenu-products[data-preview="${target}"]`);
        if (preview) {
          preview.classList.add('active');
          submenu.style.height = 'auto';
          submenu.style.height = submenu.scrollHeight + 'px';
        }
      });
    });

    // Active le premier onglet par défaut
    if (tabs.length && previews.length) {
      tabs[0].classList.add('active');
      previews[0].classList.add('active');
    }
  }
});
